// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  color: var(--ca-text-primary, #202938);
}

.delete-dialog {
  box-sizing: border-box;
  width: 100%;
  max-width: 32rem;
  padding: 0.75rem 1rem 1rem;
  color: var(--ca-text-primary, #202938);
  background: var(--ca-surface, #ffffff);
  text-align: center;
}

.delete-dialog__icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4.5rem;
  height: 4.5rem;
  margin: 0 auto 1.25rem;
  border: 1px solid transparent;
  border-radius: 50%;
}

.delete-dialog__icon-wrap--warning {
  border-color: var(--ca-warning, #b78103);
  background-color: var(--ca-warning-bg, #fff4d6);
}

.delete-dialog__icon-wrap--success {
  border-color: var(--ca-success, #198754);
  background-color: var(--ca-success-bg, #eaf7f0);
}

.delete-dialog__icon {
  display: block;
  font-size: 2.15rem;
  line-height: 1;
}

.delete-dialog__icon--warning {
  color: var(--ca-warning, #b78103);
}

.delete-dialog__icon--success {
  color: var(--ca-success, #198754);
}

.delete-dialog__content {
  max-width: 27rem;
  margin: 0 auto;
}

.delete-dialog__title {
  margin: 0 0 0.625rem;
  color: var(--ca-text-primary, #202938);
  font-size: clamp(1.35rem, 3vw, 1.7rem);
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.015em;
  overflow-wrap: anywhere;
}

.delete-dialog__message {
  margin: 0;
  color: var(--ca-text-secondary, #5c6675);
  font-size: 1rem;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.delete-dialog__actions {
  display: flex;
  justify-content: center;
  margin-top: 1.75rem;
}

.delete-dialog__actions--confirmation {
  flex-wrap: wrap;
  gap: 0.75rem;
}

.delete-dialog__button {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 7rem;
  min-height: 2.75rem;
  padding: 0.7rem 1.35rem;
  border: 1px solid transparent;
  border-radius: var(--ca-radius-md, 0.5rem);
  font: inherit;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.delete-dialog__button:active {
  transform: translateY(1px);
}

.delete-dialog__button:focus-visible {
  outline: 3px solid var(--ca-primary-light, #b8d8ff);
  outline-offset: 3px;
}

.delete-dialog__button--primary {
  border-color: var(--ca-primary, #0060d6);
  background-color: var(--ca-primary, #0060d6);
  color: #ffffff;
}

.delete-dialog__button--primary:hover {
  border-color: var(--ca-primary-dark, #1a1a86);
  background-color: var(--ca-primary-dark, #1a1a86);
}

.delete-dialog__button--secondary {
  border-color: var(--ca-border, #d7dce3);
  background-color: var(--ca-surface, #ffffff);
  color: var(--ca-text-primary, #202938);
}

.delete-dialog__button--secondary:hover {
  border-color: var(--ca-border-dark, #aab2bf);
  background-color: var(--ca-surface-hover, #f4f6f9);
}

.delete-dialog__button--danger {
  border-color: var(--ca-danger, #dc3545);
  background-color: var(--ca-danger, #dc3545);
  color: #ffffff;
}

.delete-dialog__button--danger:hover {
  filter: brightness(0.92);
}

.delete-dialog__button--danger:focus-visible {
  outline-color: var(--ca-danger, #dc3545);
}

@media (max-width: 480px) {
  .delete-dialog {
    padding: 0.25rem 0.25rem 0.5rem;
  }
  .delete-dialog__icon-wrap {
    width: 3.75rem;
    height: 3.75rem;
    margin-bottom: 1rem;
  }
  .delete-dialog__icon {
    font-size: 1.85rem;
  }
  .delete-dialog__message {
    font-size: 0.9375rem;
  }
  .delete-dialog__actions {
    margin-top: 1.4rem;
  }
  .delete-dialog__actions--confirmation {
    gap: 0.625rem;
  }
  .delete-dialog__button {
    min-width: 6.25rem;
    padding-inline: 1rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  .delete-dialog__button {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/dialogs/delete-dialog/delete-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,sCAAA;AACF;;AAEA;EACE,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,sCAAA;EACA,sCAAA;EACA,kBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;AACF;;AAEA;EACE,wCAAA;EACA,+CAAA;AACF;;AAEA;EACE,wCAAA;EACA,+CAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,sCAAA;EACA,sCAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,uBAAA;AACF;;AAEA;EACE,SAAA;EACA,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;AACF;;AAEA;EACE,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,0CAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,0HACE;AAAJ;;AAOA;EACE,0BAAA;AAJF;;AAOA;EACE,mDAAA;EACA,mBAAA;AAJF;;AAOA;EACE,wCAAA;EACA,4CAAA;EACA,cAAA;AAJF;;AAOA;EACE,6CAAA;EACA,iDAAA;AAJF;;AAOA;EACE,uCAAA;EACA,4CAAA;EACA,sCAAA;AAJF;;AAOA;EACE,4CAAA;EACA,kDAAA;AAJF;;AAOA;EACE,uCAAA;EACA,2CAAA;EACA,cAAA;AAJF;;AAOA;EACE,wBAAA;AAJF;;AAOA;EACE,wCAAA;AAJF;;AAOA;EACE;IACE,+BAAA;EAJF;EAOA;IACE,cAAA;IACA,eAAA;IACA,mBAAA;EALF;EAQA;IACE,kBAAA;EANF;EASA;IACE,oBAAA;EAPF;EAUA;IACE,kBAAA;EARF;EAWA;IACE,aAAA;EATF;EAYA;IACE,kBAAA;IACA,oBAAA;EAVF;AACF;AAaA;EACE;IACE,gBAAA;EAXF;AACF","sourcesContent":[":host {\n  display: block;\n  color: var(--ca-text-primary, #202938);\n}\n\n.delete-dialog {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 32rem;\n  padding: 0.75rem 1rem 1rem;\n  color: var(--ca-text-primary, #202938);\n  background: var(--ca-surface, #ffffff);\n  text-align: center;\n}\n\n.delete-dialog__icon-wrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 4.5rem;\n  height: 4.5rem;\n  margin: 0 auto 1.25rem;\n  border: 1px solid transparent;\n  border-radius: 50%;\n}\n\n.delete-dialog__icon-wrap--warning {\n  border-color: var(--ca-warning, #b78103);\n  background-color: var(--ca-warning-bg, #fff4d6);\n}\n\n.delete-dialog__icon-wrap--success {\n  border-color: var(--ca-success, #198754);\n  background-color: var(--ca-success-bg, #eaf7f0);\n}\n\n.delete-dialog__icon {\n  display: block;\n  font-size: 2.15rem;\n  line-height: 1;\n}\n\n.delete-dialog__icon--warning {\n  color: var(--ca-warning, #b78103);\n}\n\n.delete-dialog__icon--success {\n  color: var(--ca-success, #198754);\n}\n\n.delete-dialog__content {\n  max-width: 27rem;\n  margin: 0 auto;\n}\n\n.delete-dialog__title {\n  margin: 0 0 0.625rem;\n  color: var(--ca-text-primary, #202938);\n  font-size: clamp(1.35rem, 3vw, 1.7rem);\n  font-weight: 700;\n  line-height: 1.25;\n  letter-spacing: -0.015em;\n  overflow-wrap: anywhere;\n}\n\n.delete-dialog__message {\n  margin: 0;\n  color: var(--ca-text-secondary, #5c6675);\n  font-size: 1rem;\n  line-height: 1.65;\n  overflow-wrap: anywhere;\n}\n\n.delete-dialog__actions {\n  display: flex;\n  justify-content: center;\n  margin-top: 1.75rem;\n}\n\n.delete-dialog__actions--confirmation {\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.delete-dialog__button {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 7rem;\n  min-height: 2.75rem;\n  padding: 0.7rem 1.35rem;\n  border: 1px solid transparent;\n  border-radius: var(--ca-radius-md, 0.5rem);\n  font: inherit;\n  font-size: 0.95rem;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  transition:\n    background-color 0.2s ease,\n    border-color 0.2s ease,\n    color 0.2s ease,\n    box-shadow 0.2s ease,\n    transform 0.2s ease;\n}\n\n.delete-dialog__button:active {\n  transform: translateY(1px);\n}\n\n.delete-dialog__button:focus-visible {\n  outline: 3px solid var(--ca-primary-light, #b8d8ff);\n  outline-offset: 3px;\n}\n\n.delete-dialog__button--primary {\n  border-color: var(--ca-primary, #0060d6);\n  background-color: var(--ca-primary, #0060d6);\n  color: #ffffff;\n}\n\n.delete-dialog__button--primary:hover {\n  border-color: var(--ca-primary-dark, #1a1a86);\n  background-color: var(--ca-primary-dark, #1a1a86);\n}\n\n.delete-dialog__button--secondary {\n  border-color: var(--ca-border, #d7dce3);\n  background-color: var(--ca-surface, #ffffff);\n  color: var(--ca-text-primary, #202938);\n}\n\n.delete-dialog__button--secondary:hover {\n  border-color: var(--ca-border-dark, #aab2bf);\n  background-color: var(--ca-surface-hover, #f4f6f9);\n}\n\n.delete-dialog__button--danger {\n  border-color: var(--ca-danger, #dc3545);\n  background-color: var(--ca-danger, #dc3545);\n  color: #ffffff;\n}\n\n.delete-dialog__button--danger:hover {\n  filter: brightness(0.92);\n}\n\n.delete-dialog__button--danger:focus-visible {\n  outline-color: var(--ca-danger, #dc3545);\n}\n\n@media (max-width: 480px) {\n  .delete-dialog {\n    padding: 0.25rem 0.25rem 0.5rem;\n  }\n\n  .delete-dialog__icon-wrap {\n    width: 3.75rem;\n    height: 3.75rem;\n    margin-bottom: 1rem;\n  }\n\n  .delete-dialog__icon {\n    font-size: 1.85rem;\n  }\n\n  .delete-dialog__message {\n    font-size: 0.9375rem;\n  }\n\n  .delete-dialog__actions {\n    margin-top: 1.4rem;\n  }\n\n  .delete-dialog__actions--confirmation {\n    gap: 0.625rem;\n  }\n\n  .delete-dialog__button {\n    min-width: 6.25rem;\n    padding-inline: 1rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .delete-dialog__button {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
